import { Component, DestroyRef, EventEmitter, Inject, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { AppService } from 'src/app/app.service';
import { transformIntoApiCallObjWithoutClientId } from 'src/app/gdo/gdo-shared/Models/Constants';

@Component({
    selector: 'app-gdo-view-invoice',
    templateUrl: './gdo-view-invoice.component.html',
    styleUrls: ['./gdo-view-invoice.component.scss'],
    standalone: false
})
export class GdoViewInvoiceComponent implements OnInit {

  private readonly destroyRef = inject(DestroyRef);

  onCloseDialog = new EventEmitter();

  viewReport: string = ""

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public matDialogRef: MatDialogRef<GdoViewInvoiceComponent>, private appService: AppService) { }


  ngOnInit(): void {
    
    
    if (this.data) {
      this.viewReport = this.data.htmlReport;
      if (this.data.download) {

        setTimeout(() => {
          this.convetToPDF();
        }, 1);

      }
    }
  }

  onDownload() {
    this.convetToPDF();
  }

  onClickClose(): void {
    this.matDialogRef.close();
  }

  public convetToPDF() {
    this.downloadForSmallScreens()
    // if (window.innerWidth < 700) {
    //   this.downloadForSmallScreens();
    // } else {
    //   this.downloadForLargeScreens();
    // }
  }

  downloadForSmallScreens() {
    let data : any = {};
    data.statement_no = this.data.statement_no;

    data = transformIntoApiCallObjWithoutClientId(data, "GetStatmentForPDF");
    
    this.appService.GetStatementAsPDF(data).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
    
    
    if(res && res.status === "SUCCESS"){
      const source = `data:application/pdf;base64,${res.pdf_file_byte}`;
      const link = document.createElement("a");
      link.href = source;
      link.download = `${this.data.statement_no}.pdf`;
      link.click();
    }

    }, (error)=>{
      
    })

    // capture my on screen html

    // let html = document.getElementById('view_invoice_report').outerHTML;

    // // create the iframe
    // let iframe = document.createElement("iframe");
    // iframe.style.width = "100%";
    // iframe.style.height = "100%";

    // document.body.appendChild(iframe);
    // // add html to iframe
    // iframe.srcdoc = html;


    // let invoice_no = this.data.invoice_no
    // let matDialog = this.matDialogRef



    // // wait for iframe to load
    // iframe.addEventListener("load", () => {
    //   // use html2canvas to save the webpage
    //   let html2canvasOptions = {
    //     allowTaint: true,
    //     removeContainer: true,
    //     imageTimeout: 15000,
    //     logging: true,
    //     useCORS: true,
    //     scale: 2
    //   };
    //   html2canvas(iframe.contentWindow.document.body, html2canvasOptions).then(function (canvas) {
    //     document.body.removeChild(iframe)
    //     var imgWidth = 208;
    //     var pageHeight = 295;
    //     var imgHeight = canvas.height * imgWidth / canvas.width;
    //     var heightLeft = imgHeight;

    //     const contentDataURL = canvas.toDataURL('image/png')
    //     let pdf = new jsPDF('p', 'pt', [canvas.width, canvas.height]);
    //     var imgData = canvas.toDataURL("image/png", 1.0);
    //     pdf.addImage(imgData, 0, 0, canvas.width, canvas.height);
    //     // var position = 0;
    //     // pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST')
    //     // var data: any = document.getElementById('view_invoice_report');
    //     // document.body.removeChild(iframe)
    //     pdf.save(`${invoice_no}.pdf`); // Generated PDF
    //     matDialog.close()
    //   });
    // });
  }

  downloadForLargeScreens() {
    var data: any = document.getElementById('view_invoice_report');

    let html2canvasOptions = {
      allowTaint: true,
      removeContainer: true,
      backgroundColor: null,
      imageTimeout: 15000,
      logging: true,
      scale: 2,
      useCORS: true
    };
    html2canvas(data, html2canvasOptions).then(canvas => {

      // Few necessary setting options
      const contentDataURL = canvas.toDataURL('image/png')
      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight;
      let pdf = new jsPDF('p', 'mm', 'a4', true); // A4 size page of PDF
      let position = 0;

      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'FAST')
        heightLeft -= pageHeight;
      }
      pdf.save(`${this.data.invoice_no}.pdf`); // Generated PDF
    })
  }
}

